import type { JSX } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ImpersonationBanner } from '@/features/auth/components/ImpersonationBanner';
import { AiAssistantPanel } from '@/features/ai-assistant';
// import { useAuthStore } from '@/features/auth/stores/authStore';

export function AppLayout(): JSX.Element {
  // TODO: Re-enable when AI Assistant is production-ready
  // const showAiAssistant = !!useAuthStore((state) => state.getEffectiveCompanyId());
  const showAiAssistant = false;

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col md:ml-0">
        <ImpersonationBanner />
        <Header />
        <main className={`flex-1 overflow-auto p-4 md:p-6 ${showAiAssistant ? 'pb-24' : ''}`}>
          <Outlet />
        </main>
        {showAiAssistant && <AiAssistantPanel />}
      </div>
    </div>
  );
}
